import { render, staticRenderFns } from "./regional.vue?vue&type=template&id=018cbb2d&scoped=true&"
import script from "./regional.vue?vue&type=script&lang=js&"
export * from "./regional.vue?vue&type=script&lang=js&"
import style0 from "./regional.vue?vue&type=style&index=0&id=018cbb2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018cbb2d",
  null
  
)

export default component.exports